const uiCaptions = {
    swRoundTrip:"3C4E7130-3BA8-4A53-9AC9-20AE470926AD",
    swMultiCity:"BC30446E-7DB6-4D6A-B253-1D4FCEF6E027",
    dpDeparture:"2E11A2AF-6C36-4033-9E3F-38DB094B7CBF",
    dpReturn:"ECE32B09-2F42-44F5-BAF8-4BEE80F518D0",
    btSearch:"AFF3B122-4A3A-4638-8889-F8955AF79554",
};

export default uiCaptions;